<script lang="ts">
import { defineComponent } from 'vue';
import IconSports from '@/helpers/icon-pack-sports.vue';
import { getIconAlias } from '@/utils/transform';
import { formatDate } from '@/utils/format';
import TableFiller from '@/components/table-filler.vue';
import ClipboardIcon from '@/components/clipboard-icon.vue';
import Decimal from 'decimal.js-light';

export default defineComponent({
  name: 'events',
  components: { ClipboardIcon, TableFiller, IconSports },
  computed: {
    eventId: {
      get() {
        return this.fixtureId;
      },
      set(v: number) {
        this.$emit('update:fixtureId', v);
      },
    },
  },
  methods: {
    getIconAlias,
    formatDate,
    diff(event, index: number) {
      const home = event.Markets[index].Selections.find(
        (s: { Outcome?: { Name: string } }) =>
          s.Outcome?.Name && ['Home', 'Player 1'].includes(s.Outcome?.Name)
      );
      const away = event.Markets[index].Selections.find(
        (s: { Outcome?: { Name: string } }) =>
          s.Outcome?.Name && ['Away', 'Player 2'].includes(s.Outcome?.Name)
      );

      if (home && away) {
        const min = Math.min(home.Decimal, away.Decimal);
        const max = Math.max(home.Decimal, away.Decimal);

        return new Decimal(max).sub(min).div(min).mul(100).toFixed(1);
      }
      return 100;
    },
  },
  emits: ['update:fixtureId'],
  props: ['events', 'pageSize', 'fixtureId'],
});
</script>

<template>
  <table class="basic-table">
    <thead>
      <tr>
        <th style="width: 100px">ID</th>
        <th style="width: 35px"></th>
        <th style="min-width: 300px" class="!text-left">Матч</th>
        <th style="width: 120px">Начало</th>
        <th>Турнир</th>
        <th style="width: 160px">Регион</th>
        <th class="!text-right text-nowrap">
          <i class="pi pi-arrows-v text-xs mr-2" /><i class="pi pi-percentage text-xs" />
        </th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="event in events" @click="eventId = event.Id">
        <td>
          {{ event.Id }}
          <clipboard-icon :text="event.Id" iconClass="text-xs" />
        </td>
        <td>
          <IconSports :id="getIconAlias(event.Sport.Id)" :height="20" :width="20" />
        </td>
        <td class="!text-left text-nowrap">
          <router-link
            :to="{ name: 'detailed-event', params: { id: event.Id } }"
            class="underline cursor-pointer text-blue-500 !text-sm mr-0.5"
          >
            {{ event.Name }}
          </router-link>
          <clipboard-icon :text="event.Name" iconClass="text-xs" icon="pi-file-word" />
        </td>
        <td class="text-nowrap">
          {{ formatDate(event.StartTimeUtc, 'DD.MM.YYYY') }}
          <span class="text-gray-500">{{ formatDate(event.StartTimeUtc, 'HH:mm') }}</span>
        </td>
        <td class="text-nowrap">{{ event.Competition.Name }}</td>
        <td>{{ event.Competition.Region.Name }}</td>
        <td class="!text-right font-mono">
          <template v-for="(_, i) in event.Markets" :key="_.Id">
            <div class="">{{ diff(event, i) }}</div>
          </template>
        </td>
      </tr>
      <table-filler :max="pageSize" :rows="events" />
    </tbody>
  </table>
</template>

<style scoped lang="scss"></style>
